import React from 'react';
import { Divider } from 'antd';
import { Resolutions } from '../../../types/banner';
import { useResponsiveSizes } from '../../../hooks/use-responsive-sizes';
import { getIconsForResolution } from './get-icons';

interface ResolutionInfoProps {
  resolution: string | null;
}

export const ResolutionInfo: React.FC<ResolutionInfoProps> = ({ resolution }) => {
  const { spacing, fontSize } = useResponsiveSizes();

  if (!resolution) return null;

  return (
    <div style={{ textAlign: 'center', marginTop: spacing.md }}>
      <div style={{ fontSize: fontSize.base, color: '#6b7280', marginBottom: spacing.sm }}>
        Resolución actual: <strong style={{ fontWeight: 700, color: '#4B5563' }}>{resolution}</strong>
      </div>

      <Divider style={{ margin: `${spacing.sm}px 0` }} />

      <div
        style={{
          fontSize: fontSize.base,
          fontStyle: 'italic',
          color: '#6b7280',
          textAlign: 'center',
          marginBottom: spacing.sm
        }}
      >
        Plataformas sugeridas
      </div>

      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          gap: spacing.xs,
          marginTop: spacing.xs
        }}
      >
        {getIconsForResolution(resolution as Resolutions)}
      </div>
    </div>
  );
};
